__turbopack_context__.v({
  "banner": "BannerComponent-module-scss-module__gUsp2a__banner",
  "message": "BannerComponent-module-scss-module__gUsp2a__message",
});
